<template>
  <div>
    <div class="row section-top">
      <div class="col-md-12 pad0">
        <p class="section-lead">Lista de todos Local de Trabalho cadastrados</p>
        <a href="/admin/workplaces/create" class="btn btn-outline-success float-right">
          <i class="fas fa-plus"></i>&nbsp;Novo
        </a>
        <div class="dropdown float-right mr-2">
          <button
            class="btn btn-outline-secondary dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fas fa-download"></i> Exportar
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" href="#" @click.prevent="exportData('pdf')">PDF</a>
            <a class="dropdown-item" href="#" @click.prevent="exportData('csv')">Excel</a>
            <div class="dropdown-divider"></div>
            <a
              class="dropdown-item"
              href="#"
              @click.prevent="$refs.gridfullexport.showModal('work_places', 'work_places')"
            >
              Completo
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="card p-4">
          <vue-good-table
            v-if="workplacesItems.length"
            :columns="tableColumns"
            :rows="workplacesItems"
            :totalRows="tablePaginationOptions.total"
            :pagination-options="paginationOptions"
            :search-options="{ enabled: true, placeholder: 'Buscar..' }"
            @on-page-change="onPageChange"
            @on-per-page-change="onPerPageChange"
            styleClass="vgt-table"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field === 'actions'">
                <button
                  class="btn btn-sm btn-outline-secondary"
                  v-if="userCan.edit"
                  @click="editData(props.row)"
                  title="Editar"
                >
                  <i class="far fa-edit"></i>
                </button>
                <button
                  class="btn btn-sm btn-outline-danger"
                  v-if="userCan.delete"
                  @click="deleteData(props.row.id, props.rowIndex)"
                  title="Deletar"
                >
                  <i class="far fa-trash-alt"></i>
                </button>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>

          <div v-else class="text-center p-3 text-muted">
            <h5>Nenhum local de trabalho cadastrado!</h5>
          </div>
        </div>

        <div class="text-center p-4 text-muted" v-if="loading">
          <h5>Carregando...</h5>
          <p>Aguarde até que os dados sejam carregados...</p>
        </div>
      </div>

      <gridfullexport-component ref="gridfullexport"></gridfullexport-component>
      <vue-loading
        color="#212121"
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="fullPage"
      ></vue-loading>
    </div>
  </div>
</template>

<script>
import ApiService from '../../apiservice.js';
import ExportGrid from '../../exportgrid.js';
import configData from '../../config.js';

export default {
  mixins: [ApiService, configData, ExportGrid],
  props: ['permissions'],
  data() {
    return {
      workplacesItems: [],
      fullPage: true,
      errors: [],
      loading: false,
      tableColumns: [
        { label: 'ID', field: 'id' },
        { label: 'Nome do Local', field: 'corporate_name' },
        { label: 'CNPJ', field: 'cnpj' },
        { label: 'Empresa', field: 'companyworkplaces.company.corporate_name' },
        { label: 'Tipo', field: 'company_types.name' },
        {
          label: 'Data e Hora',
          field: 'created_at',
          type: 'date',
          dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXX",
          dateOutputFormat: 'dd/MM/yyyy HH:mm:ss',
        },
        { label: 'Ações', field: 'actions', sortable: false, width: '100px' },
      ],
      tablePaginationOptions: {
        currentPage: 1,
        currentPerPage: configData.tablePagination.perPage,
        total: 0,
      },
      paginationOptions: {
        enabled: configData.tablePagination.enabled,
        mode: configData.tablePagination.mode,
        perPage: configData.tablePagination.perPage,
        perPageDropdown: [10, 50, 100, 500],
        dropdownAllowAll: configData.tablePagination.dropdownAllowAll,
        nextLabel: configData.tablePagination.nextLabel,
        prevLabel: configData.tablePagination.prevLabel,
        rowsPerPageLabel: configData.tablePagination.rowsPerPageLabel,
        ofLabel: configData.tablePagination.ofLabel,
        pageLabel: configData.tablePagination.pageLabel,
        allLabel: configData.tablePagination.allLabel,
      },
      userCan: null,
    };
  },
  mounted() {
    this.userCan = JSON.parse(this.permissions);
    if (this.userCan.list) {
      this.loadItems();
    }
  },
  methods: {
    onPageChange(params) {
      this.tablePaginationOptions.currentPage = params.currentPage;
      this.loadItems();
    },
    onPerPageChange(params) {
      this.tablePaginationOptions.currentPerPage = params.currentPerPage;
      this.tablePaginationOptions.currentPage = 1;
      this.loadItems();
    },
    loadItems() {
      this.loading = true;
      const params = {
        page: this.tablePaginationOptions.currentPage,
        perPage: this.tablePaginationOptions.currentPerPage,
      };
      axios
        .post('/admin/workplaces/filter', {}, { params })
        .then((res) => {
          const { data, total } = res.data.data;
          this.workplacesItems = data;
          this.tablePaginationOptions.total = total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    exportData(type) {
      const tempForm = $('#vgt-table');
      if (type === 'pdf') {
        this._exportPDF(
          'Local de Trabalho',
          [6],
          tempForm,
          ['ID', 'Nome do Local', 'CNPJ', 'Empresa', 'Tipo', 'Data e Hora']
        );
      } else {
        this._exportExcel(
          'Local de Trabalho',
          [6],
          tempForm,
          ['ID', 'Nome do Local', 'CNPJ', 'Empresa', 'Tipo', 'Data e Hora']
        );
      }
    },
    deleteData(id, index) {
      this.$swal({
        title: 'Excluir Local de Trabalho',
        text: 'Tem certeza que deseja excluir esse Local de Trabalho?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          axios
            .delete(`/admin/workplaces/${id}`)
            .then((res) => {
              this.workplacesItems.splice(index, 1);
              this._api_validateSuccess(res, true);
              this.loading = false;
            })
            .catch((err) => {
              this.loading = false;
              this._api_validateError(err);
            });
        }
      });
    },
    editData(item) {
      location.href = `/admin/workplaces/${item.id}/edit`;
    },
    resetForm() {
      this.workplace = {
        corporate_name: '',
        country: '',
        cnpj: '',
        address: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
        cep: '',
        company_type_id: '',
      };
      this.errors = [];
    },
  },
};
</script>
